import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';

function TabTimePeriod({ createInput }) {
  return (
    <>
      {createInput('startDate', 'dateTime', true, 'col-lg-3 col-12 session-label-align', 'col-lg-6 col-12')}
      {createInput('endDate', 'dateTime', true, 'col-lg-3 col-12 session-label-align', 'col-lg-6 col-12')}
      {createInput(
        'confirmationLinkTime',
        'dateTime',
        true,
        'col-lg-3 col-12 session-label-align',
        'col-lg-6 col-12',
        undefined,
        undefined,
        true,
      )}
    </>
  );
}

TabTimePeriod.propTypes = {
  createInput: PropTypes.func.isRequired,
};

export default translate(TabTimePeriod);
